import axios from 'axios';
import { ApiConfig, HttpMethod, DynamicUrl } from '../constant';

const URL_CONTACTS = '/callbar/contacts';

/* contacts */
export const contactList: ApiConfig = {
  url: URL_CONTACTS,
  cancelPrev: false,
  ignoreError: true,
};

export const contactsDetail: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CONTACTS}/${id}`,
  cancelPrev: false,
  ignoreError: true,
};

export const contactsDetailWithCustomUrl: ApiConfig<DynamicUrl> = {
  url: (url: string | number) => String(url),
  cancelPrev: false,
};

/* agents */
export const agentList: ApiConfig = {
  url: '/graph/users',
  embeddedField: 'users',
  cancelPrev: false,
  ignoreError: true,
};

/* role */
export const role: ApiConfig = {
  url: '/acls/role/subjects/user',
  embeddedField: 'role',
};

/* Permission */
export const permission: ApiConfig = {
  url: '/policies/evaluate/bulk',
  method: HttpMethod.POST,
};

/* email */
export const emailTouchpoints: ApiConfig = {
  url: '/eas/email-touchpoints',
  embeddedField: 'touchpoints',
};

export const emailMessagesWithPage: ApiConfig = {
  url: '/cds/messages',
  embeddedField: 'message',
};

export const emailSend: ApiConfig = {
  url: '/eas/emails',
  method: HttpMethod.POST,
};

export const emailCheckStatus: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `/eas/emails/jobs/${String(id)}`,
};

export const emailAttachments: ApiConfig = {
  url: '/assets',
  cancelPrev: false,
};

export const emailAttachmentDownload: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `/assets/${id}/download-link`,
  cancelPrev: false,
};

export const emailAttachmentDelete: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `/assets/${id}`,
  method: HttpMethod.PATCH,
  cancelPrev: false,
};

export const emailAttachmentClone: ApiConfig<DynamicUrl> = {
  url: (source_id: string | number) => `/assets?source_id=${String(source_id)}`,
  method: HttpMethod.POST,
  cancelPrev: false,
};

/* assets */
export const assetsRequests: ApiConfig = {
  url: '/assets-requests',
  method: HttpMethod.POST,
  cancelPrev: false,
};

export const assetsUploadFile: ApiConfig<DynamicUrl> = {
  url: (url: string | number) => String(url),
  method: HttpMethod.PUT,
  axiosInstance: axios,
  cancelPrev: false,
};

export const assetsCreate: ApiConfig = {
  url: '/assets',
  method: HttpMethod.POST,
  cancelPrev: false,
};

export const assetsDelete: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `/assets/${String(id)}`,
  ignoreError: true,
  method: HttpMethod.DELETE,
  cancelPrev: false,
};

export const assetsDownload: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `/assets/${String(id)}/download-link`,
  cancelPrev: false,
};

/* voicemails */
export const voicemailsTranscription: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `/voicemails/${String(id)}/transcription`,
  cancelPrev: false,
  ignoreError: true,
};

export const voicemailsDetail: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `/voicemails/${String(id)}`,
  cancelPrev: false,
  ignoreError: true,
};

/* omnichannel */
export const omnichannelInteractions: ApiConfig = {
  url: '/omnichannel/inbox/interactions/bulk',
  method: HttpMethod.POST,
  cancelPrev: false,
  ignoreError: true,
};

export const omnichannelInteractionsActions: ApiConfig<DynamicUrl> = {
  url: (interaction_id: string | number) => `/omnichannel/inbox/interactions/${String(interaction_id)}/actions`,
  method: HttpMethod.POST,
};

/* phones */
export const accountPhones: ApiConfig = {
  url: '/account/phones',
  ignoreError: true,
};
